import React, { useContext, useEffect, useState } from 'react'
import DataTable from '@/Components/Common/DataTableWithAutoPagination';
import { AgencyContext } from 'Context/Agency';
import { Link, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPostData } from '@/Components/hooks/Api';
import { Decrypt_Id_Name, getShowingDateText, tableCustomStyles } from '@/Components/Common/Utility';
import { get_ScreenPermissions_Data } from '@/redux/actions/IncidentAction';


const OwnerHistory = (props) => {

    const { DecNameID, DecMasterNameID, } = props

    const dispatch = useDispatch();
    const localStoreData = useSelector((state) => state.Agency.localStoreData);
    const uniqueId = sessionStorage.getItem('UniqueUserID') ? Decrypt_Id_Name(sessionStorage.getItem('UniqueUserID'), 'UForUniqueUserID') : '';
    const [OwnerHistory, setOwnerHistoryData] = useState([]);
    const effectiveScreenPermission = useSelector((state) => state.Incident.effectiveScreenPermission);


    const useQuery = () => {
        const params = new URLSearchParams(useLocation().search);
        return {
            get: (param) => params.get(param)
        };
    };

    const { nameFilterData, setIncidentStatus } = useContext(AgencyContext);

    useEffect(() => {
        if (localStoreData) {
            dispatch(get_ScreenPermissions_Data("V085", localStoreData?.AgencyID, localStoreData?.PINID));
        }
    }, [localStoreData]);

    let openPage = useQuery().get('page');
    let MstPage = useQuery()?.get('page');

    useEffect(() => {
        if (DecNameID || DecMasterNameID) { Get_OwnerHistory(DecNameID, DecMasterNameID); }
    }, [DecNameID, DecMasterNameID])


    const Get_OwnerHistory = (DecNameID, DecMasterNameID) => {
        console.log("@@DecMasterNameID", DecMasterNameID)
        const val1 = {
            'NameID': DecNameID, 'MasterNameID': DecMasterNameID, 'IsMaster': MstPage === "MST-Name-Dash" ? true : false,
        }
        const val2 = {
            'NameID': 0, 'MasterNameID': DecMasterNameID, 'IsMaster': true,
        }
        fetchPostData('TransactionLog/GetData_OwnerHistory', MstPage === "MST-Property-Dash" ? val2 : val1).then((res) => {
            if (res) {
                console.log(res)
                setOwnerHistoryData(res)
            } else {
                setOwnerHistoryData();
            }
        })
    }

    const columns = [
        {
            // width: '120px',
            name: 'Property/Vehicle #',
            selector: (row) => row.TransactionNumber,
            sortable: true
        },
        {
            // width: '180px',
            name: 'Property/Vehicle Category',
            selector: (row) => row.PropertyCategory,
            sortable: true
        },
        {
            // width: '180px',
            name: 'Lastname',
            selector: (row) => row.LastName,
            sortable: true
        },
        {
            // width: '180px',
            name: 'Firstname',
            selector: (row) => row.FirstName,
            sortable: true
        },
        {
            // width: '180px',
            name: 'Middlename',
            selector: (row) => row.MiddleName,
            sortable: true
        },
        {
            // width: '180px',
            name: 'Gender',
            selector: (row) => row.Sex_Description,
            sortable: true
        },

    ]

    return (

        <div className="col-md-12 mt-2">
            <div className="col-12">
                <DataTable
                    dense
                    columns={columns}
                    data={effectiveScreenPermission ? effectiveScreenPermission[0]?.DisplayOK ? OwnerHistory : [] : OwnerHistory}
                    noDataComponent={effectiveScreenPermission ? effectiveScreenPermission[0]?.DisplayOK ? "There are no data to display" : "You don’t have permission to view data" : 'There are no data to display'}
                    pagination
                    selectableRowsHighlight
                    highlightOnHover
                    responsive
                    showPaginationBottom={10}
                    fixedHeader
                    persistTableHead={true}
                    customStyles={tableCustomStyles}
                />
            </div>
        </div>



    )
}

export default OwnerHistory